import {BaseVueEntity} from "@/entities/BaseVueEntity";
import {isDefined} from "@/utils";
import moment from "moment";
import langHelper from "@/locales/langHelper";

export class Speech extends BaseVueEntity {


  private readonly _begin: string;
  private readonly _end: string;
  private readonly _info: string;
  private readonly _infoLang: string;
  private readonly _category: string;
  private readonly _place: string;
  private readonly _stand: string;
  private readonly _title: string;
  private readonly _sortOrder: string;
  private readonly _themes: string[];
  private readonly _hasTranslation: boolean;
  private readonly _speakers: Person[] = [];
  private readonly _subTitle: string;
  private readonly _sponsor: string;
  private readonly _searchList: string[];
  private readonly _logoPath: string;

  constructor(entity, logoPath) {
    super();
    this._begin = entity.BEGINN;
    this._end = entity.ENDE;
    this._info = entity.INFO;
    this._infoLang = entity.INFO_LANG;
    this._category = entity.KATEGORIE;
    this._place = entity.ORT;
    this._stand = entity.STAND;
    this._title = entity.TITEL;
    this._sortOrder = entity.S_ORDER;
    this._themes = entity.THEMEN;
    this._hasTranslation = entity.HAT_UEBERSETZUNG;
    this._subTitle = entity.UNTERTITEL;
    this._sponsor = entity.SPONSOR;

    if (isDefined(entity.SUCHWORTLISTE)) {
      this._searchList = entity.SUCHWORTLISTE.split('|');
    }

    if (isDefined(entity.PERSONEN) && Array.isArray(entity.PERSONEN) && entity.PERSONEN.length > 0) {
      entity.PERSONEN = entity.PERSONEN.map(e => {
        return new Person(e)
      });
      for (const person of entity.PERSONEN) {
          this._speakers.push(person);
      }
    }

    this._logoPath = logoPath;
  }


  static comparator(a: Speech, b: Speech): number {
    return moment(a.begin).valueOf() - moment(b.begin).valueOf();
  }

  public hasSearchValue(value: string): boolean {
    for (const prop of ['_title', '_subTitle', '_info', '_place', '_infoLang', '_sponsor', '_searchList']) {
      if (isDefined(this[prop]) && Array.isArray(this[prop])) {
        return this[prop].findIndex(e => e.toLowerCase().indexOf(value) > -1) > -1;
      }
      if (isDefined(this[prop]) && this[prop].toLowerCase().indexOf(value) > -1) {
        return true;
      }
    }
    return false;
  }

  get beginTime(): string {
    return moment(this._begin).locale(langHelper.getCurrentLang()).format("HH:mm");
  }

  get endTime(): string {
    return moment(this._end).locale(langHelper.getCurrentLang()).format("HH:mm");
  }

  get startDate(): string {
    const lang = langHelper.getCurrentLang();
    if (lang == 'de') {
      return moment(this._begin).locale(langHelper.getCurrentLang()).format("Do MMMM YYYY");
    } else {
      return moment(this._begin).locale(langHelper.getCurrentLang()).format("D MMMM YYYY");
    }
  }

  get begin(): string {
    return this._begin;
  }

  get end(): string {
    return this._end;
  }

  get info(): string {
    return this._info;
  }

  get category(): string {
    return this._category;
  }

  get place(): string {
    return this._place;
  }

  get stand(): string {
    return this._stand;
  }

  get title(): string {
    return this._title;
  }

  get sortOrder(): string {
    return this._sortOrder;
  }

  get logoPath(): string {
    return this._logoPath;
  }


  get themes(): string[] {
    return this._themes;
  }

  get languageID(): string {
    if (isDefined(this.themes)) {
      return this.themes.find(t => t.includes('EVENTS_BY_LANGUAGE'));
    }
    return undefined;
  }

  get hasTranslation(): boolean {
    return this._hasTranslation;
  }


  get speakers(): Person[] {
    return this._speakers;
  }
}


export class Person {
  private readonly _id: string;
  private readonly _role: string;
  private readonly _sortOrder: string;

  constructor(entity) {
    this._id = entity.ID;
    this._role = entity.ROLLE;
    this._sortOrder = entity.S_ORDER;
  }


  get id(): string {
    return this._id;
  }

  get role(): string {
    return this._role;
  }

  get sortOrder(): string {
    return this._sortOrder;
  }
}

export namespace Person {
  export enum Role {
    "MODERATOR" = "M",
    "SPEAKER" = "S"
  }
}
